import { RouteName } from "../RouteNames";

export const transcriptionsRoutes = {
  name: RouteName.TranscriptionsRoot,
  path: "transcriptions",
  redirect: () => ({
    name: RouteName.Transcriptions,
  }),

  children: [
    {
      name: RouteName.Transcriptions,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/TranscriptionsView.vue"),
    },
    {
      name: RouteName.TranscriptionZoom,
      path: ":transcriptionId",
      component: () =>
        import("@follaw-fr/views/side_menu_views/TranscriptionsZoomView.vue"),
    },
  ],
};
